export const EXTERNAL_LINKS = {
    ORDER_PROPANE: 'https://www.avenirenergy.ca/contact-avenir-energy-request-propane-refill',
    CONTACT_US: 'https://www.avenirenergy.ca/about-us-contact-avenir-energy',
    AVENIR_HOME: 'https://www.avenirenergy.ca/'
}